<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-26 18:15:08
 * @LastEditTime: 2019-09-25 10:46:13
 * @LastEditors: Please set LastEditors
 -->

<template>
    <div id="page_Container" class="searchContent">
        <div class="page">
            <form action="/">
                <van-search
                    v-model="value"
                    placeholder="请输入搜索关键词"
                    show-action
                    @search="onSearch"
                    @cancel="onCancel"
                />
            </form>
            <div v-if="list.length" id="main-container" class="main-container searchHistory">
                <div class="historyTop">
                    <span>历史搜索</span>
                    <img @click="deleteFun" src="../assets/img/myCenter/deleteCart.png" alt="">
                </div>
                <div class="historyBottom" id="historyBottom" :class="{hidden: hiddenFlag}">
                    <span v-for="(item, index) in list" @click="spanClick(item)" :key="index">{{item}}</span>
                </div>
                <div class="triangleContent" v-if="triangleShow" @click="triangleFun">
                    <div class="triangle"></div>
                </div>
            </div>
            <van-dialog class="dialogStyle"
                v-model="show"
                message="确认删除全部历史记录？"
                show-cancel-button
                @confirm="confirm"
                >
            </van-dialog>
        </div>
    </div>
</template>
<script>
import {
    mapGetters,
    mapActions
} from 'vuex';
export default {
    name: 'home',
    data() {
        return {
            triangleShow: false,
            value: '',
            valueOld: '',
            hiddenFlag: false,
            list: [],
            show: false
        };
    },
    computed: {
        ...mapGetters(['searchInfo'])
    },
    esvShow: function() {
        this.ESVStorage.getSavedValue('list', (data) => {
            this.list = data !== '' ? data : [];
        });
        setTimeout(() => {
            if (document.getElementById('historyBottom').offsetHeight > 86) {
                this.hiddenFlag = true;
                this.triangleShow = true;
            } else {
                this.hiddenFlag = false;
                this.triangleShow = false;
            }
        });
        this.value = this.searchInfo.productName;
        this.valueOld = this.searchInfo.productName;
    },
    destroyed() {
        this.$route.query.searchType = '';
        this.hiddenFlag = false;
        this.triangleShow = false;
    },
    methods: {
        ...mapActions(['setSearchInfo']),
        spanClick(item) {
            console.log(item);
            this.value = item;
            this.onSearch();
        },
        onSearch() {
            const ths = this;
            if (ths.value.trim()) {
                ths.list.forEach((item, index) => {
                    if (index > 13) {
                        ths.list.splice(index, 1);
                    }
                    if (item === ths.value) {
                        ths.list.splice(index, 1);
                    }
                });
                ths.list.unshift(ths.value);
                ths.ESVStorage.putSavedValue('list', ths.list);
                ths.ESVStorage.putSavedValue('searchMassage', ths.value);
                this.setSearchInfo({ productName: ths.value.trim(), searchTypes: '1', styleType: '2', searchFlag: 'search' });
            } else {
                this.setSearchInfo({ productName: '', searchTypes: '1', styleType: '1', searchFlag: 'search' });
            }
            this.hiddenFlag = false;
            this.triangleShow = false;

            ths.esvOpenPage({ name: 'OPGoodlist',
                params: { retailStoreProductFlag: this.$route.params.retailStoreProductFlag
                } });
        },
        onCancel() {
            let styleType;
            if (this.value.trim()) {
                styleType = '1';
            } else {
                styleType = '2';
            }
            this.esvBackPage(1, true, () => {
                this.setSearchInfo({ ...this.searchInfo, productName: this.valueOld, searchFlag: 'search', styleType });
            });
        },
        triangleFun() {
            this.hiddenFlag = false;
            this.triangleShow = false;
        },
        deleteFun() {
            this.show = true;
        },
        confirm() {
            this.list = [];
            this.ESVStorage.removeSavedValue('list');
        }
    }
};

</script>
<style lang="scss" scoped>
.searchContent {
    background: #fff;
    .searchHistory {
        position: relative;
        padding-bottom: 47px;
        .historyTop {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin: 10px 12px 0;
            span {
                line-height: 20px;
                color: #414141;
                font-size: 14px;
            }
            img {
                width: 19px;
                height: 20px;
            }
        }
        .historyBottom {
            font-size: 0;
            margin: 12px 12px 0;
            height: auto;
            span{
                max-width: 100%;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                display: inline-block;
                margin: 0 10px 10px 0;
                font-size: 14px;
                background: #f6f6f6;
                padding: 6px 15px;
                border-radius: 16px;
            }
        }
        .hidden {
            max-height: 84px;
            overflow: hidden;
        }
        .triangleContent {
            position: absolute;
            width: 100%;
            height: 30px;
            display: flex;
            justify-content: center;
            align-items: center;
           .triangle {
                display: inline-block;
                width: 0;
                height: 0;
                border-top-width: 7px;
                border-left-width: 7px;
                border-right-width: 7px;
                border-style: solid;
                border-color: #999 transparent transparent transparent;
           }
           .triangleTransform {
                transform: rotate(180deg)
           }
        }
    }
}
</style>
